import { ICard } from '../@types/index.react';

export interface ISubformInlineEditPublishObj {
  dataRestrictDelete: string;
  dataRestrictEdit: string;
  fieldId: number;
  fieldIdentifier: string;
  formIdentifier: string;
  formLocale: string;
  uuid: string;
}

export type IOnSubformInlineEdit = (
  e: JQuery.ClickEvent,
  basePubObj: IDCA.IInlineEditPublishObj,
  pubObj: ISubformInlineEditPublishObj
) => any;

export function onSubformInlineEdit(
  e: JQuery.ClickEvent,
  basePubObj: IDCA.IInlineEditPublishObj,
  pubObj: ISubformInlineEditPublishObj
) {
  const { tdElement } = basePubObj;
  const {
    dataRestrictDelete,
    dataRestrictEdit,
    // fieldId,
    // fieldIdentifier,
    formIdentifier,
    formLocale,
    uuid,
  } = pubObj;
  const { ownerIdentifier } = window.DexeroCoreApp.userOptions;
  const $tr = tdElement.closest('tr');
  const $actionTd = $tr.find('.actions');
  const $viewButton = $actionTd.find('.view-button');
  const $editButton = $actionTd.find('.edit-button');
  const $deleteButton = $actionTd.find('.delete-button');

  function cardDeleteIsRestricted(card: ICard) {
    if (getFieldValue(dataRestrictDelete, card).indexOf('1') !== -1) {
      return true;
    }
    return false;
  }

  function cardEditIsRestricted(card: ICard) {
    if (getFieldValue(dataRestrictEdit, card).indexOf('1') !== -1) {
      return true;
    }
    return false;
  }

  function getFieldValue(fieldIdentToCheck: string, card: ICard): any[] {
    const fields = card.cardFields;
    const valuesToReturn: any[] = [];
    Object.keys(fields).some((fieldIdent) => {
      const { identifier, values } = fields[fieldIdent];
      if (identifier === fieldIdentToCheck) {
        if (values) {
          for (const value of values) {
            valuesToReturn.push(value.valueId);
          }
        }
        return true;
      }
      return false;
    });

    return valuesToReturn;
  }

  function toggleInlineEdit(action: 'off' | 'on') {
    const $tds = $tr.find('td:not(.actions)');
    $tds.each((_, td) => {
      const $td = $(td);
      if ($td.hasClass('inline-edit-wrapper')) {
        const $triggerButton = $td.find('button.open-inline-edit');
        if (action === 'off') {
          $td.addClass('disabled');
          $triggerButton.addClass('disabled hide');
        } else {
          $td.removeClass('disabled');
          $triggerButton.removeClass('disabled hide');
        }
      }
    });
  }

  (async () => {
    const swaggerClient = await window.DexeroCoreApp.getSwaggerClient();
    const swaggerObj = { formIdentifier, uuid, ownerIdentifier, lang: formLocale };
    const cardResponse = await swaggerClient.apis.cards.getCard(swaggerObj);
    const card = cardResponse.body;
    const restrictEdit = cardEditIsRestricted(card);
    const restrictDelete = cardDeleteIsRestricted(card);
    if (restrictEdit) {
      $editButton.addClass('hide');
      $viewButton.removeClass('hide');
      toggleInlineEdit('off');
    } else {
      $editButton.removeClass('hide');
      $viewButton.addClass('hide');
      toggleInlineEdit('on');
    }
    if (restrictDelete) {
      $deleteButton.addClass('hide');
    } else {
      $deleteButton.removeClass('hide');
    }
  })().catch((event) => {
    if (window.console) {
      console.error(event);
    }
  });
}
